/**
 *
 * @param skill
 */
export function getDescription(skill) {
    return skill.description;
}
/**
 *
 * @param skill
 */
export function getEntityTypeId(skill) {
    return skill.entityTypeId;
}
/**
 *
 * @param skill
 */
export function getExpertise(skill) {
    return skill.expertise;
}
/**
 *
 * @param skill
 */
export function getHalfProficiency(skill) {
    return skill.halfProficiency;
}
/**
 *
 * @param skill
 */
export function getId(skill) {
    return skill.id;
}
/**
 *
 * @param skill
 */
export function getIsOverridden(skill) {
    return skill.isOverridden;
}
/**
 *
 * @param skill
 */
export function getModifier(skill) {
    return skill.modifier;
}
/**
 *
 * @param skill
 */
export function getModifierBonuses(skill) {
    return skill.modifierBonuses;
}
/**
 *
 * @param skill
 */
export function getName(skill) {
    return skill.name;
}
/**
 *
 * @param skill
 */
export function getProficiency(skill) {
    return skill.proficiency;
}
/**
 *
 * @param skill
 */
export function getProficiencyBonus(skill) {
    return skill.proficiencyBonus;
}
/**
 *
 * @param skill
 */
export function getProficiencyLevel(skill) {
    return skill.proficiencyLevel;
}
/**
 *
 * @param skill
 */
export function getStat(skill) {
    return skill.stat;
}
/**
 *
 * @param skill
 */
export function getStatModifier(skill) {
    return skill.statModifier;
}
/**
 *
 * @param skill
 */
export function isCustom(skill) {
    return skill.isCustom;
}
/**
 *
 * @param skill
 */
export function getNotes(skill) {
    return skill.notes;
}
/**
 *
 * @param skill
 */
export function getOriginalContract(skill) {
    return skill.originalContract;
}
/**
 *
 * @param skill
 */
export function getAdvantageAdjustments(skill) {
    return skill.advantageAdjustments;
}
/**
 *
 * @param skill
 */
export function getDisadvantageAdjustments(skill) {
    return skill.disadvantageAdjustments;
}
/**
 *
 * @param skill
 */
export function getUsableDiceAdjustmentType(skill) {
    return skill.usableDiceAdjustmentType;
}
